// import { Login } from "@/api/interface/index";
// import { PORT1 } from "@/api/config/servicePort";
import authMenuList from "@/assets/json/authMenuList.json";
import request from "@/api/axios";
import { AUTH_SERVICE } from "@/api/config/servicePort";

/**
 * @name 登录模块
 */
// 用户登录
export const loginApi = (data: any): Promise<IResponse> => {
  return request.post({ url: AUTH_SERVICE + "/phone/login", data });
};

// 获取菜单列表
export const getAuthMenuListApi = (params: any) => {
  // return request.get<Menu.MenuOptions[]>(PORT1 + `/menu/list`, {}, { loading: false });
  // 如果想让菜单变为本地数据，注释上一行代码，并引入本地 authMenuList.json 数据
  return request.get({ url: AUTH_SERVICE + "/getMenuList", params }, { noLoading: false });
  return authMenuList;
  return { code: 200, data: [] };
};

export const getRoleMenusApi = (params: any, noLoading: boolean = true): Promise<IResponse> => {
  return request.get({ url: AUTH_SERVICE + "/getMenuList", params }, { noLoading });
};
